export default {
  SET_INIT_SEARCH_DATA(state, result) {
    state.customSearchResults = [...result];
  },
  RESET_CUSTOM_SEARCH_RESULTS(state) {
    state.customSearchResults = [];
  },
  SET_SEARCH_VARIANTS(state, searchVariants) {
    state.searchVariants = searchVariants;
  },
  SET_SELECTED_SEARCH_VARIANT(state, selectedSearchVariant) {
    state.selectedSearchVariant = selectedSearchVariant;
  },
  SET_LOADING_VARIANT(state, isLoading) {
    state.isLoading = isLoading;
  },
};
